import { useState } from "react";
import { ChevronDown, ChevronUp, Ruler } from "lucide-react";

const LENS_KEY = {
  partner: "partner",
  investor: "investor",
};

export function FloorAreaInsight({ insight, lens }) {
  const [expanded, setExpanded] = useState(false);

  if (!insight?.available) return null;

  const lensKey = LENS_KEY[lens] || "public";
  const copy = insight.copy?.[lensKey] || insight.copy?.public;
  if (!copy) return null;

  const borderColor =
    insight.density_band === "Low"
      ? "border-amber-500/20"
      : insight.density_band === "Spacious"
      ? "border-cipher-green/20"
      : "border-blue-500/20";

  const bgColor =
    insight.density_band === "Low"
      ? "bg-amber-500/10"
      : insight.density_band === "Spacious"
      ? "bg-cipher-green/10"
      : "bg-blue-500/10";

  const iconColor =
    insight.density_band === "Low"
      ? "text-amber-400"
      : insight.density_band === "Spacious"
      ? "text-cipher-green"
      : "text-blue-400";

  return (
    <div
      className={`mb-6 rounded-xl border ${borderColor} ${bgColor} overflow-hidden transition-all`}
      data-testid="floor-area-insight"
    >
      <button
        onClick={() => setExpanded(!expanded)}
        className="w-full flex items-center justify-between px-4 py-3 text-left group"
        data-testid="floor-area-insight-toggle"
      >
        <div className="flex items-center gap-2.5">
          <div className="w-8 h-8 rounded-lg bg-white/10 flex items-center justify-center flex-shrink-0">
            <Ruler className={`w-4 h-4 ${iconColor}`} />
          </div>
          <div>
            <p className="text-sm font-medium text-white">Space & Layout</p>
            <p className="text-[11px] text-white/40">{insight.source_note}</p>
          </div>
        </div>
        {expanded ? (
          <ChevronUp className="w-4 h-4 text-white/40 group-hover:text-white/70 transition-colors" />
        ) : (
          <ChevronDown className="w-4 h-4 text-white/40 group-hover:text-white/70 transition-colors" />
        )}
      </button>

      {expanded && (
        <div className="px-4 pb-4 animate-in slide-in-from-top-1 duration-200">
          <p className="text-sm text-white/70 leading-relaxed">{copy}</p>

          {insight.has_conflict && insight.conflict_note && (
            <p className="text-xs text-amber-400/80 mt-2 leading-relaxed">
              {insight.conflict_note}
            </p>
          )}

          {insight.inspection_date && (
            <p className="text-[10px] text-white/30 mt-2">
              Floor-area record dated {insight.inspection_date}
            </p>
          )}
        </div>
      )}
    </div>
  );
}
